import { Component, OnInit, AfterViewInit, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import { PaginatedResponse, PaginationInfo } from 'src/app/shared/models';
import { DailyCurrencyRateService } from 'src/app/services/daily-currency/daily-currency-rate.service';
import { CurrencyRateModalService } from 'src/app/services/currency-rate-modal/currency-rate-modal.service';

declare var bootstrap: any;

@Component({
  selector: 'app-md-currency',
  templateUrl: './md-currency.component.html',
  styleUrls: ['./md-currency.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ height: '0px', opacity: 0 }),
        animate('300ms ease-in', style({ height: '*', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('300ms ease-out', style({ height: '0px', opacity: 0 }))
      ])
    ])
  ]
})
export class MdCurrencyComponent extends DestructorComponent implements OnInit, AfterViewInit {

  // Data properties
  currencyRates: any[] = [];
  isLoading = false;

  // Pagination
  currentPage = 1;
  paginationInfo: PaginationInfo = {
    currentPage: 1,
    perPage: 10,
    total: 0,
    lastPage: 1,
    firstPage: 1
  };

  // Search and filters
  searchTerm = '';
  showFiltersForm = false;
  filters: Record<string, any> = {};

  constructor(
    private _dailyCurrencyRateService: DailyCurrencyRateService,
    private _currencyRateModalService: CurrencyRateModalService,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    this.loadCurrencyRates();
  }

  ngAfterViewInit(): void {
    // Initialize any required UI components
  }

  loadCurrencyRates(page: number = 1, search: string = '', filters: Record<string, any> = {}): void {
    this.isLoading = true;
    this.currentPage = page;
    this.searchTerm = search;
    this.filters = filters;

    this.subscriptions.push(
      this._dailyCurrencyRateService.GetData(page.toString(), search, filters).subscribe({
        next: (response: PaginatedResponse<any>) => {
          if (response.status && response.data) {
            this.currencyRates = response.data.data || [];
            this.paginationInfo = response.data.pagination;
            this.currentPage = response.data.pagination.currentPage;
          } else {
            this.currencyRates = [];
            this.resetPagination();
          }
          this.isLoading = false;
          this.cdr.detectChanges();
        },
        error: (error) => {
          console.error('Error loading currency rates:', error);
          this.currencyRates = [];
          this.resetPagination();
          this.isLoading = false;
          this.cdr.detectChanges();
        }
      })
    );
  }

  onPageChange(page: number): void {
    this.loadCurrencyRates(page, this.searchTerm, this.filters);
  }

  toggleFilters(): void {
    this.showFiltersForm = !this.showFiltersForm;
  }

  applyFilters(): void {
    this.loadCurrencyRates(1, this.searchTerm, this.filters);
  }

  resetFilters(): void {
    this.searchTerm = '';
    this.filters = {};
    this.showFiltersForm = false;
    this.loadCurrencyRates();
  }

  openEditModal(currencyRate: any): void {
    this._currencyRateModalService.setSelectedCurrencyRate(currencyRate);
    const modalElement = document.getElementById('kt_modal_edit_currency_rate');
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    }
  }

  // Event handlers for modal events
  onCurrencyRateUpdated(): void {
    console.log('Currency rate updated, refreshing list...');
    this.loadCurrencyRates(this.currentPage, this.searchTerm, this.filters);
  }

  // Utility methods
  private resetPagination(): void {
    this.paginationInfo = {
      currentPage: 1,
      perPage: 10,
      total: 0,
      lastPage: 1,
      firstPage: 1
    };
  }

  // Track by function for ngFor performance
  trackByFn(index: number, item: any): any {
    return item.doc_id || index;
  }

  // Calculate TTB (value - 10)
  calculateTTB(value: number): number {
    return value - 10;
  }

  // Calculate TTM (value)
  calculateTTM(value: number): number {
    return value;
  }

  // Calculate TTH (value + 10)
  calculateTTH(value: number): number {
    return value + 10;
  }

  // Math utility for template
  Math = Math;
}
